export const related = [
  '/build-planner',
  '/quests/power-lines',
  '/quests/into-the-sinkhole',
];
export const quickAnswer =
  'Build Power is your overall power indicator. Update 1.4.0 shows it at the bottom-left of Loadout; being below enemy level makes combat harder.';
export const sourceIds = ['remedy-1-4-0', 'ps-ngplus'];

## Where to Find Build Power

Open Loadout and check the bottom-left number. The update makes this easier to find than the older Stats & Effects location.

## Why Build Power Matters

Treat a difficult encounter as a reason to check progression as well as combat choices. Remedy notes that fighting enemies above your level is harder.

## How to Raise Your Build Power

Continue side quests, explore and level up. Review upgrades when you return to The Gap. This guide does not claim a tested fastest farming route.

## Build Power in New Game Plus

Combat abilities, talents, artifacts, Aberrant upgrades and health/resource improvements carry forward. Traversal abilities remain tied to story progress. The planner records choices, not your actual in-game power.

## What Changed in Update 1.4.0

The visible Loadout number is a quality-of-life change. The update also introduces New Game++ for further runs. Check the official notes for platform-specific fixes.
